<app-navbar position="sticky"></app-navbar>

<div *ngIf="!isShort" class="header-container" [class.mb-5]="!isShort" [class.mb-4]="isShort"
  [ngStyle]="isShort ? {'height': '28vh'} : {'min-height': '453px'}" [ngClass]="shortHeaderClass">

  <div class="content container-xl container-fluid" *ngIf="!isShort">

    <div class="d-flex flex-column align-items-start gap-3 text-block" [ngClass]="{'d-none': isShort}">
      <h1 class="mb-0 text-black fw-bold">{{'Find out how much you can save on your smile!' | translate}} </h1>
      <span class="fs-20 text-muted">{{'Do you want a personalized quote?' | translate}} </span>
      <button [disabled]="searchbarService.allCountries.length === 0" class="btn btn-primary w-auto mt-1"
        (click)="openQuoteRequestModal()">{{'Request a quote' |
        translate}}
        <i class="ti ti-arrow-narrow-right"></i>
      </button>
    </div>

  </div>

  <div class="container-xl container-fluid">
    <div class="searchbar-wrapper d-flex w-100" [class.short-searchbar-wrapper]="isShort">
      <app-searchbar [isHomePage]="!isShort" class="w-100"></app-searchbar>
    </div>
  </div>